module.exports = __webpack_public_path__ + "static/media/us.269666d5.svg";